import { useEffect, useState } from "react";
import { Box } from "@mui/material";

import { palette } from "theme/palette";

type Props = {
  value: number;
  setValue: (value: number) => void;
  error: boolean;
  inputRef: React.Ref<HTMLInputElement>;
};

export const InputNumber = ({ value, setValue, error, inputRef }: Props) => {
  const [disabledDecrement, setDisabledDecrement] = useState(false);

  useEffect(() => {
    if (value < 1 && String(value) !== "") setValue(1);
    setDisabledDecrement(parseFloat(String(value)) === 1);
  }, [value]);

  const increment = () => {
    const num = parseFloat(String(value));
    if (isNaN(num)) return setValue(1);
    setValue(num + 1);
  };

  const decrement = () => {
    const num = parseFloat(String(value));
    if (isNaN(num)) return setValue(1);
    if (num <= 1) return;
    setValue(num - 1);
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          border: `0.5px solid ${error ? palette.error : palette.grey}`,
          borderRadius: "8px",
          overflow: "hidden",
          width: "fit-content",
          backgroundColor: "transparent",
          padding: "9px",
        }}
      >
        <button
          type="button"
          onClick={decrement}
          disabled={disabledDecrement}
          style={{
            width: "40px",
            height: "40px",
            border: "none",
            background: "transparent",
            cursor: disabledDecrement ? "default" : "pointer",
            fontSize: "20px",
            color: disabledDecrement ? palette.grey : palette.darkGrey,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: 1,
          }}
        >
          −
        </button>
        <Box
          sx={{
            minWidth: "40px",
            textAlign: "center",
            fontSize: "15px",
            fontWeight: 500,
            userSelect: "none",
            padding: "0 4px",
          }}
        >
          {value}
        </Box>
        <button
          type="button"
          onClick={increment}
          style={{
            width: "40px",
            height: "40px",
            border: "none",
            background: "transparent",
            cursor: "pointer",
            fontSize: "20px",
            color: palette.darkGrey,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: 1,
          }}
        >
          +
        </button>
      </Box>
      {/* Hidden input keeps react-hook-form registration and focus-on-error working */}
      <input
        ref={inputRef}
        type="number"
        value={value}
        onChange={() => {}}
        style={{
          position: "absolute",
          width: 0,
          height: 0,
          opacity: 0,
          pointerEvents: "none",
        }}
      />
    </Box>
  );
};
